import type { v2 } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule, validity, buildControlIdFromParent, descriptionSrcURL } from '../../../common/decoration';
import { getAppSettingOBJPathV2 } from '../../application';
import { addPatternForBindingChangeOfEnumOP } from '../../../common';
import type AvatarShape from 'sap/m/AvatarShape';

const getAvatarControlId = (baseId: string, idBreadcrumbs: string[]): string => {
    const idBreadcrumbsCopy = idBreadcrumbs.slice(0);
    idBreadcrumbsCopy[idBreadcrumbs.length - 1] = 'objectImage';
    return buildControlIdFromParent(baseId, idBreadcrumbsCopy);
};

export class ObjectPageHeader implements v2.ObjectPageHeader {
    @syncRule({
        manifest: {
            path: (pageKeys): string => getAppSettingOBJPathV2(pageKeys)
        }
    })
    @validity({
        since: '1.46.0'
    })
    showRelatedApps?: boolean;

    @syncRule({
        manifest: {
            path: (pageKeys): string => getAppSettingOBJPathV2(pageKeys)
        }
    })
    @validity({
        since: '1.46.0'
    })
    editableHeaderContent?: boolean;

    @syncRule({
        manifest: {
            path: (pageKeys): string => getAppSettingOBJPathV2(pageKeys)
        }
    })
    @validity({
        since: '1.48.0'
    })
    simpleHeaderFacets?: boolean;

    @syncRule({
        manifest: {
            path: (pageKeys): string => getAppSettingOBJPathV2(pageKeys)
        }
    })
    @validity({
        since: '1.48.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/17dbd5b7a61e4cdcb079062e976cd63f')
    showHeaderAsCarouselOnDesktop?: boolean;

    @syncRule({
        flex: {
            controlId: getAvatarControlId,
            controlType: (): ControlType => ControlType.Avatar
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    displayShape?: AvatarShape;

    actions?: v2.ObjectPageHeaderActions;
}
